module.exports = __webpack_public_path__ + "img/shiba-head-level5.187596a6.png";